/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

import classNames from 'classnames';

import styles from './ClaimBookingRadioGroup.module.scss';

type Sailor = {
  clientId: string;
  [key: string]: any;
};

type ClaimBookingRadioGroupProps = {
  sailors: Sailor[];
  selectedSailor: Sailor;
  onChange: (selectedSailor: Sailor) => void;
  labelFunction: (sailor: Sailor, index: number) => React.ReactNode;
};

const ClaimBookingRadioGroup: React.FC<ClaimBookingRadioGroupProps> = ({
  sailors,
  selectedSailor,
  onChange,
  labelFunction,
}) => {
  const [value, setValue] = useState(selectedSailor);

  const handleRadioSelection = (selectedValue: Sailor) => {
    setValue(selectedValue);
    onChange(selectedValue);
  };

  return (
    <div className={styles.radio}>
      <div className={styles.labels} role="radiogroup">
        {sailors.map((sailor, index) => {
          const elementId = `item-${sailor.clientId}`;

          return (
            <div className={styles.radioLabel} key={sailor.clientId}>
              <label
                htmlFor={elementId}
                className={classNames(styles.label, { [styles.labelChecked]: value.clientId === sailor.clientId })}
              >
                {labelFunction(sailor, index)}
              </label>
              <input
                id={elementId}
                type="radio"
                name="claim-booking-radio-sailor-select"
                value={sailor.clientId}
                checked={value.clientId === sailor.clientId}
                onChange={() => handleRadioSelection(sailor)}
                tabIndex={value.clientId === sailor.clientId ? 0 : -1}
                className={styles.radioInput}
              />
              <hr className={styles.radioDivider} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ClaimBookingRadioGroup;
